<template lang="pug">
  v-menu(
    v-model="isActive"
    eager
    nudge-right="0"
    transition="scale-transition"
    min-width="290px"
    :offset-y="true"
    :disabled="disabled"
    :close-on-content-click="false"
  )
    template(v-slot:activator="{ on, attrs }")
      v-text-field(
        v-on="on"
        v-bind="attrs"
        readonly
        dense
        :value="lazyValue"
        :label="label"
        :clearable="clearable"
        :disabled="disabled"
        :rules="rules"
        @click:clear="clear"
      )
    v-time-picker(
      v-model="lazyValue"
      ref="timePickerRef"
      :locale="$i18n.locale"
      :format="format"
      @change="onChanged"
    )
</template>
<script>
import { ref } from 'vue';
import { useModelBinding } from '@/helpers/misc/binding';

export default {
  name: 'PhoTimePicker',
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
    },
    displayFormat: {
      type: String,
      default: 'HH:mm',
    },
    format: {
      type: String,
      default: '24hr',
    },
    label: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const isActive = ref(false);
    const timePickerRef = ref(null);
    const { lazyValue, updateValue } = useModelBinding(emit, props);

    const onChanged = newValue => {
      updateValue(newValue);
      isActive.value = false;
      timePickerRef.value.selectingHour = true;
    };

    const clear = () => {
      updateValue(undefined);
      lazyValue.value = undefined;
      timePickerRef.value.selectingHour = true;
    };

    return {
      isActive,
      timePickerRef,
      lazyValue,
      onChanged,
      clear,
    };
  },
};
</script>
